export default "__VITE_ASSET__413eb620__"